import { api } from "../utils/api";
import { normalizeGeneralBoardConfig } from "../utils/generalBoardConfig";
import {
  emptyGeneralBoard,
  normalizeBoardPayload
} from "../utils/generalBoardPeriods";

const getConfig = async () => {
  const res = await api.get("ClassDiaryV1/general-board/settings");
  return normalizeGeneralBoardConfig(res.data);
};

const saveConfig = async config => {
  const res = await api.put("ClassDiaryV1/general-board/settings", config);
  return normalizeGeneralBoardConfig(res.data);
};

const getBoard = async (classId, periods) => {
  let periodParam;
  if (Array.isArray(periods)) {
    periodParam = periods.filter(Boolean).join(",");
  } else if (periods) {
    periodParam = String(periods);
  }
  const res = await api.get(
    `ClassDiaryV1/general-board/${encodeURIComponent(classId)}`,
    { params: periodParam ? { period: periodParam } : undefined }
  );
  return normalizeBoardPayload(res.data || emptyGeneralBoard());
};

export default {
  getConfig,
  saveConfig,
  getBoard
};
